import { useRef, useState } from 'react';
import type { ReactNode } from 'react';
import type { Photo } from 'app/types/commonTypes.type';
import type { ListingVideo } from 'app/types/listingDetails.type';
import { MediaCenterTabs } from './MediaCenterTabs';
import { PhotosTab } from './PhotosTab';
import { ThreeDTourTab } from './ThreeDTourTab';
import { VideosTab } from './VideosTab';
import type { MediaCenterTab } from './MediaCenterTabs';

type MediaCenterContentProps = {
  open: boolean;
  photos: Array<Photo>;
  tourUrls: Array<string>;
  tourLabels?: Array<string>;
  has3dTour: boolean;
  hasVideos?: boolean;
  videos?: Array<ListingVideo>;
  previewPhoto?: Photo;
  initialTab?: MediaCenterTab;
  headerActions?: ReactNode;
};

export const MediaCenterContent = ({
  open,
  photos,
  tourUrls,
  tourLabels = [],
  has3dTour,
  hasVideos,
  videos = [],
  previewPhoto,
  initialTab = 'photos',
  headerActions,
}: MediaCenterContentProps) => {
  const [activeTab, setActiveTab] = useState<MediaCenterTab>(initialTab);

  // Reset tab when opening with a different initialTab
  const prevOpenRef = useRef(open);
  if (open && !prevOpenRef.current) {
    setActiveTab(initialTab);
  }
  prevOpenRef.current = open;

  return (
    <>
      <MediaCenterTabs activeTab={activeTab} onTabChange={setActiveTab} has3dTour={has3dTour} hasVideos={hasVideos} />
      {activeTab === 'photos' && <PhotosTab photos={photos} headerActions={headerActions} />}
      {activeTab === '3dtour' && (
        <ThreeDTourTab tourUrls={tourUrls} tourLabels={tourLabels} photos={photos} previewPhoto={previewPhoto} />
      )}
      {activeTab === 'videos' && <VideosTab videos={videos} photos={photos} previewPhoto={previewPhoto} />}
    </>
  );
};
